<template>
  <div class="innerPage">
    <div>

    </div>
    <div class="innerPageHead">
      <div class="innerPageTitle">
        <h2>{{ $t("TopNav04") }}</h2>
      </div>
      <div class="innerPagePagination">
        <b-container>
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-container>
      </div>
    </div>

    <div class="interPageMainContain">

      <b-container>
        <b-card no-body>
          <b-tabs card>
            <b-tab :title="$t('tab01')" active>
              <b-card-text>
                <div class="timeline">
                  <article class="item">
                    <div class="time">09:00–09:30</div>
                    <div class="content">
                      <div class="bar">{{ $t("Registration") }}</div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">09:30–09:50</div>
                    <div class="content">
                      <div class="bar opening">
                        <div class="opening-row">
                          <div class="opening-title">{{ $t("0-1_Agenda") }}</div>
                          <div class="opening-host">
                            <button class="speaker" data-name="李遠" data-role="HOST" data-title="文化部部長"
                              :data-image="translatedSpeakers[0].image" data-bio="擔任文化部部長，並於本次論壇開幕式擔任主持人。"
                              data-speech="開幕式主持人" @click="openModal(0)">
                              <span class="speaker-box">
                                <b-img :src="translatedSpeakers[0].image" fluid :alt="translatedSpeakers[0].name"></b-img>
                                <span>
                                  <span class="role">{{ $t(translatedSpeakers[0].role) }}</span>
                                  <span class="name">{{ translatedSpeakers[0].name }}</span>
                                  <span class="title">{{ translatedSpeakers[0].title }}</span>
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="info">
                        <div class="opening-head">
                          <div class="opening-host"></div>
                        </div>
                        <div class="speaker-grid">
                          <button class="speaker" data-name="陳濟民" data-role="OPENING REMARKS" data-title="文化部文化資產局局長"
                            :data-image="translatedSpeakers[1].image" data-bio="擔任文化部文化資產局局長，於本次論壇代表大會主席致歡迎詞。"
                            data-speech="大會主席致歡迎詞" @click="openModal(1)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[1].image" fluid :alt="translatedSpeakers[1].name"></b-img>
                              <span>
                                <span class="role">{{ $t(translatedSpeakers[1].role) }}</span>
                                <span class="name">{{ translatedSpeakers[1].name }}</span>
                                <span class="title">{{ translatedSpeakers[1].title }}</span>
                              </span>
                            </span>
                          </button>

                          <button class="speaker" data-name="李遠" data-role="OPENING REMARKS" data-title="文化部部長"
                            :data-image="translatedSpeakers[2].image" data-bio="擔任文化部部長，於本次論壇進行長官致詞。" data-speech="長官致詞"
                            @click="openModal(2)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[2].image" fluid :alt="translatedSpeakers[2].name"></b-img>
                              <span>
                                <span class="role">{{ $t(translatedSpeakers[2].role) }}</span>
                                <span class="name">{{ translatedSpeakers[2].name }}</span>
                                <span class="title">{{ translatedSpeakers[2].title }}</span>
                              </span>
                            </span>
                          </button>

                          <button class="speaker" data-name="Marion Steiner" data-role="OPENING REMARKS"
                            data-title="國際工業遺產保存委員會（TICCIH）主席" :data-image="translatedSpeakers[3].image"
                            data-bio="擔任國際工業遺產保存委員會（TICCIH）主席，長期投入工業遺產保存及國際合作。" data-speech="預錄致詞" @click="openModal(3)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[3].image" fluid :alt="translatedSpeakers[3].name"></b-img>
                              <span>
                                <span class="role">{{ $t(translatedSpeakers[3].role) }}</span>
                                <span class="name">{{ translatedSpeakers[3].name }}</span>
                                <span class="title">{{ translatedSpeakers[3].title }}</span>
                              </span>
                            </span>
                          </button>


                        </div>
                      </div>
                    </div>
                  </article>

                  <div class="session">
                    <div><span class="session-topics">{{ $t("Session1_topic") }}</span>{{ $t("Session1_title") }}</div>
                    <button class="speaker host-speaker" data-name="陳濟民" data-role="HOST" data-title="文化部文化資產局局長"
                      :data-image="translatedSpeakers[4].image" data-bio="擔任文化部文化資產局局長，於專題一擔任主持人。"
                      data-speech="專題一：價值思辨－世界遺產與產業文化資產價值" @click="openModal(4)">
                      <span class="speaker-box">
                        <b-img :src="translatedSpeakers[4].image" fluid :alt="translatedSpeakers[4].name"></b-img>
                        <span><span class="role">{{ $t(translatedSpeakers[4].role) }}</span><span class="name">{{ translatedSpeakers[4].name }}</span><span
                            class="title">{{ translatedSpeakers[4].title }}</span></span></span>
                    </button>
                  </div>

                  <article class="item">
                    <div class="time">09:50–10:20</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session1_1-1") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="傅朝卿" data-role="KEYNOTE SPEAKER"
                          data-title="國立成功大學建築學系名譽教授、第43屆行政院文化獎得主" :data-image="translatedSpeakers[5].image"
                          data-bio="長期投入臺灣建築史、工業文化資產保存及文化遺產教育推廣。" data-speech="工業文化遺產之保存與永續經營：臺灣經驗（暫定）"
                          @click="openModal(5)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[5].image" fluid :alt="translatedSpeakers[5].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[5].role) }}</span><span class="name">{{ translatedSpeakers[5].name }}</span><span
                                class="title">{{ translatedSpeakers[5].title }}</span></span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">10:20–10:50</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session1_1-2") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="Moulshri Joshi" data-role="KEYNOTE SPEAKER"
                          data-title="國際工業遺產保存委員會（TICCIH）亞太區副主席" :data-image="translatedSpeakers[6].image"
                          data-bio="投入工業遺產保存、國際合作與亞太區文化資產網絡發展。" data-speech="全球視角下的產業文化資產保存概念：TICCIH 與區域組織的協作策略（暫定）"
                          @click="openModal(6)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[6].image" fluid :alt="translatedSpeakers[6].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[6].role) }}</span><span class="name">{{ translatedSpeakers[6].name }}</span><span
                                class="title">{{ translatedSpeakers[6].title }}</span></span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">10:50–11:00</div>
                    <div class="content break">
                      <div class="bar gray">{{ $t("Break") }}</div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">11:00–11:30</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session1_1-3") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="Faisal Abd Rahman" data-role="KEYNOTE SPEAKER"
                          data-title="ICOMOS 馬來西亞分會主席" :data-image="translatedSpeakers[7].image"
                          data-bio="關注遺產保存、永續旅遊與馬來西亞工業文化資產實務。" data-speech="遺產保存與現代需求的平衡：ICOMOS 視角下的馬來西亞工業遺產永續旅遊實踐（暫定）"
                          @click="openModal(7)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[7].image" fluid :alt="translatedSpeakers[7].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[7].role) }}</span><span class="name">{{ translatedSpeakers[7].name }}</span><span
                                class="title">{{ translatedSpeakers[7].title }}</span></span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">11:30–12:00</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session1_1-4") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="西川 三津子" data-role="KEYNOTE SPEAKER"
                          data-title="日本工業遺產資訊中心（IHIC）總經理" :data-image="translatedSpeakers[8].image"
                          data-bio="投入日本工業遺產資訊整合、價值詮釋與推廣工作。" data-speech="明治工業革命遺址的價值論述與推廣策略（暫定）"
                          @click="openModal(8)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[8].image" fluid :alt="translatedSpeakers[8].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[8].role) }}</span><span class="name">{{ translatedSpeakers[8].name }}</span><span
                                class="title">{{ translatedSpeakers[8].title }}</span></span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">12:00–12:30</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session1_1-5") }}</div>
                      <div class="info">
                        <div class="speaker-grid">
                          <button class="speaker" data-name="傅朝卿" data-role="PANELIST"
                            data-title="國立成功大學建築學系名譽教授、第43屆行政院文化獎得主" :data-image="translatedSpeakers[9].image"
                            data-bio="臺灣建築史與工業文化資產保存專家。" data-speech="座談一：世界遺產與產業文化資產價值" @click="openModal(9)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[9].image" fluid :alt="translatedSpeakers[9].name"></b-img>
                              <span><span class="role">{{ $t(translatedSpeakers[9].role) }}</span><span class="name">{{ translatedSpeakers[9].name }}</span><span
                                  class="title">{{ translatedSpeakers[9].title }}</span></span></span>
                          </button>
                          <button class="speaker" data-name="Moulshri Joshi" data-role="PANELIST"
                            data-title="TICCIH 亞太區副主席" :data-image="translatedSpeakers[10].image"
                            data-bio="工業遺產保存與亞太區國際合作專家。" data-speech="座談一：世界遺產與產業文化資產價值" @click="openModal(10)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[10].image" fluid :alt="translatedSpeakers[10].name"></b-img>
                              <span><span class="role">{{ $t(translatedSpeakers[10].role) }}</span><span class="name">{{ translatedSpeakers[10].name }}</span><span
                                  class="title">{{ translatedSpeakers[10].title }}</span></span></span>
                          </button>
                          <button class="speaker" data-name="Faisal Abd Rahman" data-role="PANELIST"
                            data-title="ICOMOS 馬來西亞分會主席" :data-image="translatedSpeakers[11].image" data-bio="遺產保存與永續旅遊專家。"
                            data-speech="座談一：世界遺產與產業文化資產價值" @click="openModal(11)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[11].image" fluid :alt="translatedSpeakers[11].name"></b-img>
                              <span><span class="role">{{ $t(translatedSpeakers[11].role) }}</span><span class="name">{{ translatedSpeakers[11].name }}</span><span
                                  class="title">{{ translatedSpeakers[11].title }}</span></span></span>
                          </button>
                          <button class="speaker" data-name="西川 三津子" data-role="PANELIST"
                            data-title="日本工業遺產資訊中心（IHIC）總經理" :data-image="translatedSpeakers[12].image"
                            data-bio="日本工業遺產資訊與推廣實務工作者。" data-speech="座談一：世界遺產與產業文化資產價值" @click="openModal(12)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[12].image" fluid :alt="translatedSpeakers[12].name"></b-img>
                              <span><span class="role">{{ $t(translatedSpeakers[12].role) }}</span><span class="name">{{ translatedSpeakers[12].name }}</span><span class="title">{{ translatedSpeakers[12].title }}</span></span></span>
                          </button>
                          <button class="speaker" data-name="林曉薇" data-role="MODERATOR"
                            data-title="亞洲產業文化資產平臺指導委員會召集人、中原大學建築系教授" :data-image="translatedSpeakers[13].image"
                            data-bio="投入產業文化資產保存、教育與跨域合作。" data-speech="座談一：世界遺產與產業文化資產價值" @click="openModal(13)">
                            <span class="speaker-box">
                              <b-img :src="translatedSpeakers[13].image" fluid :alt="translatedSpeakers[13].name"></b-img>
                              <span><span class="role">{{ $t(translatedSpeakers[13].role) }}</span><span class="name">{{ translatedSpeakers[13].name }}</span><span
                                  class="title">{{ translatedSpeakers[13].title }}</span></span></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">12:30–13:30</div>
                    <div class="content break">
                      <div class="bar gray">{{ $t("Lunch") }}</div>
                    </div>
                  </article>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab :title="$t('tab02')">
              <b-card-text>
                <div class="timeline">
                  <div class="session">
                    <div><span class="session-topics">{{ $t("Session2_topic") }}</span>{{ $t("Session2_title") }}</div>                    
                    <button class="speaker host-speaker" data-role="HOST"
                      data-title="亞洲產業文化資產平臺指導委員會召集人、中原大學建築系教授" :data-image="translatedSpeakers[14].image"
                      data-bio="投入產業文化資產保存、教育與跨域合作，於專題二擔任主持人。" data-speech="專題二：跨界對話－企業 ESG 視角下的工業遺產保存實踐"
                      @click="openModal(14)">
                      <span class="speaker-box">
                        <b-img :src="translatedSpeakers[14].image" fluid :alt="translatedSpeakers[14].name"></b-img>

                        <span><span class="role">{{ $t(translatedSpeakers[14].role) }}</span><span class="name">{{ translatedSpeakers[14].name }}</span><span
                            class="title">{{ translatedSpeakers[14].title }}</span></span></span>
                    </button>
                  </div>

                  <article class="item">
                    <div class="time">13:30–14:00</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session2_2-1") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="Miles Oglethorpe" data-role="KEYNOTE SPEAKER"
                          data-title="國際工業遺產保存委員會（TICCIH）前主席、特別顧問" :data-image="translatedSpeakers[15].image"
                          data-bio="國際工業遺產保存與再生領域專家。" data-speech="【專題演講】認識、記錄與守護我們的工業遺產"
                          @click="openModal(15)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[15].image" fluid :alt="translatedSpeakers[15].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[15].role) }}</span><span class="name">{{ translatedSpeakers[15].name }}</span><span
                                class="title">{{ translatedSpeakers[15].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">14:00–14:20</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session2_2-2") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="魏家珮" data-role="SPEAKER" data-title="台灣水泥股份有限公司和平廠廠長(邀請中)"
                          :data-image="translatedSpeakers[16].image" data-bio=""
                          data-speech="台灣水泥產業的場域活化與永續發展(暫定)" @click="openModal(16)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[16].image" fluid :alt="translatedSpeakers[16].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[16].role) }}</span><span class="name">{{ translatedSpeakers[16].name }}</span><span
                                class="title">{{ translatedSpeakers[16].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">14:20–14:40</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session2_2-3") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="黃建龍" data-role="SPEAKER" data-title="台灣糖業股份有限公司董事長室特別助理"
                          :data-image="translatedSpeakers[17].image" data-bio="" data-speech="【專題演講】不只ESG，產業遺產的無限可能"
                          @click="openModal(17)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[17].image" fluid :alt="translatedSpeakers[17].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[17].role) }}</span><span class="name">{{ translatedSpeakers[17].name }}</span><span
                                class="title">{{ translatedSpeakers[17].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                <article class="item">
                    <div class="time">14:40–15:00</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session2_2-4") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="Miles Oglethorpe" data-role="PANELIST"
                          data-title="國際工業遺產保存委員會（TICCIH）前主席、特別顧問" :data-image="translatedSpeakers[18].image" data-bio="國際工業遺產保存專家。"
                          data-speech="座談二：企業 ESG 視角下的工業遺產保存實踐" @click="openModal(18)"><span class="speaker-box">
                            <b-img :src="translatedSpeakers[18].image" fluid :alt="translatedSpeakers[18].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[18].role) }}</span><span class="name">{{ translatedSpeakers[18].name }}</span><span
                                class="title">{{ translatedSpeakers[18].title }}</span></span></span></button>
                        <button class="speaker" data-name="魏家珮" data-role="PANELIST" data-title="台灣水泥股份有限公司和平廠廠長(邀請中)"
                          :data-image="translatedSpeakers[19].image" data-bio="電業文化資產與企業溝通實務。"
                          data-speech="座談二：企業 ESG 視角下的工業遺產保存實踐" @click="openModal(19)"><span class="speaker-box">
                            <b-img :src="translatedSpeakers[19].image" fluid :alt="translatedSpeakers[19].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[19].role) }}</span><span class="name">{{ translatedSpeakers[19].name }}</span><span
                                class="title">{{ translatedSpeakers[19].title }}</span></span></span></button>
                        <button class="speaker" data-name="黃建龍" data-role="PANELIST" data-title="台灣糖業股份有限公司董事長室特別助理"
                          :data-image="translatedSpeakers[20].image" data-bio="【專題演講】不只ESG，產業遺產的無限可能"
                          data-speech="座談二：企業 ESG 視角下的工業遺產保存實踐" @click="openModal(20)"><span class="speaker-box"><b-img
                              :src="translatedSpeakers[20].image" fluid :alt="translatedSpeakers[20].name"></b-img><span><span
                                class="role">{{ $t(translatedSpeakers[20].role) }}</span><span class="name">{{ translatedSpeakers[20].name }}</span><span
                                class="title">{{ translatedSpeakers[20].title }}</span></span></span></button>
                        <button class="speaker" data-name="林宜珍" data-role="MODERATOR"
                          data-title="國立臺灣科技大學通識教育中心助理教授（邀請中）" :data-image="translatedSpeakers[21].image"
                          data-bio="關注產業文化資產、通識教育與跨域實踐。" data-speech="座談二：企業 ESG 視角下的工業遺產保存實踐" @click="openModal(21)"><span
                            class="speaker-box"><b-img :src="translatedSpeakers[21].image" fluid
                              :alt="translatedSpeakers[21].name"></b-img><span><span class="role">{{ $t(translatedSpeakers[21].role) }}</span><span
                                class="name">{{ translatedSpeakers[21].name }}</span><span class="title">{{ translatedSpeakers[21].title }}</span></span></span></button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">15:00–15:20</div>
                    <div class="content break">
                      <div class="bar gray">{{ $t("Break") }}</div>
                    </div>
                  </article>

                  <div class="session">
                    <div><span class="session-topics">{{ $t("Session3_topic") }}</span>{{ $t("Session3_title") }}</div>
                    <button class="speaker host-speaker" data-name="王新衡" data-role="HOST"
                      data-title="國立雲林科技大學文化資產維護系副教授" :data-image="translatedSpeakers[22].image"
                      data-bio="投入文化資產維護、地方實踐與永續發展，於專題三擔任主持人。" data-speech="專題三：傳承永續－青年世代的產業文化資產保存行動"
                      @click="openModal(22)">
                      <span class="speaker-box">
                        <b-img :src="translatedSpeakers[22].image" fluid :alt="translatedSpeakers[22].name"></b-img>
                        <span><span class="role">{{ $t(translatedSpeakers[22].role) }}</span><span class="name">{{ translatedSpeakers[22].name }}</span><span
                            class="title">{{ translatedSpeakers[22].title }}</span></span></span>
                    </button>
                  </div>

                <article class="item">
                    <div class="time">15:20–15:50</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session3_3-1") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="鄭銘彰" data-role="SPEAKER" data-title="國家鐵道博物館籌備處主任"
                          :data-image="translatedSpeakers[23].image" data-bio="投入鐵道文化資產保存、博物館籌備與人才培育。"
                          data-speech="從工業遺產到鐵道博物館──文資與鐵道專業的共創實踐" @click="openModal(23)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[23].image" fluid :alt="translatedSpeakers[23].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[23].role) }}</span><span class="name">{{ translatedSpeakers[23].name }}</span><span
                                class="title">{{ translatedSpeakers[23].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                <article class="item">
                    <div class="time">15:50–16:20</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session3_3-2") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="顏彬峰" data-role="SPEAKER" data-title="國立虎尾科技大學永續發展暨社會責任處助理教授"
                          :data-image="translatedSpeakers[24].image" data-bio="投入地方創生、糖業文化路徑與永續發展實踐。"
                          data-speech="好糖，文化翻轉：糖都Eco-museum行動-糖業文化路徑與文資青年共創實踐" @click="openModal(24)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[24].image" fluid :alt="translatedSpeakers[24].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[24].role) }}</span><span class="name">{{ translatedSpeakers[24].name }}</span><span
                                class="title">{{ translatedSpeakers[24].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">16:20–16:50</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session3_3-3") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="徐聖凱" data-role="SPEAKER" data-title="中央研究院臺灣史研究所助研究員"
                          :data-image="translatedSpeakers[25].image" data-bio="研究臺灣產業史、礦業勞動記憶與地方社會。"
                          data-speech="看不見的，也是遺產：臺灣煤礦垂直歷史的記錄與轉譯 " @click="openModal(25)">
                          <span class="speaker-box">
                            <b-img :src="translatedSpeakers[25].image" fluid :alt="translatedSpeakers[25].name"></b-img>
                            <span><span class="role">{{ $t(translatedSpeakers[25].role) }}</span><span class="name">{{ translatedSpeakers[25].name }}</span><span
                                class="title">{{ translatedSpeakers[25].title }}</span></span></span>
                        </button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">16:50–17:10</div>
                    <div class="content">
                      <div class="bar">{{ $t("Session3_3-4") }}</div>
                      <div class="speaker-grid">
                        <button class="speaker" data-name="鄭銘彰" data-role="PANELIST" data-title="國家鐵道博物館籌備處主任"
                          :data-image="translatedSpeakers[26].image" data-bio="鐵道文化資產與博物館實務。"
                          data-speech="座談三：青年世代的產業文化資產保存行動" @click="openModal(26)"><span class="speaker-box"><b-img
                              :src="translatedSpeakers[26].image" fluid :alt="translatedSpeakers[26].name"></b-img><span><span
                                class="role">{{ $t(translatedSpeakers[26].role) }}</span><span class="name">{{ translatedSpeakers[26].name }}</span><span
                                class="title">{{ translatedSpeakers[26].title }}</span></span></span>
                        </button>
                        <button class="speaker" data-name="顏彬峰" data-role="PANELIST" data-title="國立虎尾科技大學助理教授"
                          :data-image="translatedSpeakers[27].image" data-bio="糖業文化路徑與地方共創實務。"
                          data-speech="座談三：青年世代的產業文化資產保存行動" @click="openModal(27)"><span class="speaker-box"><b-img
                              :src="translatedSpeakers[27].image" fluid :alt="translatedSpeakers[27].name"></b-img><span><span
                                class="role">{{ $t(translatedSpeakers[27].role) }}</span><span class="name">{{ translatedSpeakers[27].name }}</span><span
                                class="title">{{ translatedSpeakers[27].title }}</span></span></span>
                        </button>
                        <button class="speaker" data-name="徐聖凱" data-role="PANELIST" data-title="中央研究院臺灣史研究所助研究員"
                          :data-image="translatedSpeakers[28].image" data-bio="產業史與礦業勞動記憶研究者。"
                          data-speech="座談三：青年世代的產業文化資產保存行動" @click="openModal(28)"><span class="speaker-box"><b-img
                              :src="translatedSpeakers[28].image" fluid :alt="translatedSpeakers[28].name"></b-img><span><span
                                class="role">{{ $t(translatedSpeakers[28].role) }}</span><span class="name">{{ translatedSpeakers[28].name }}</span><span
                                class="title">{{ translatedSpeakers[28].title }}</span></span></span>
                          </button>
                        <button class="speaker" data-name="王淳熙" data-role="MODERATOR"
                          data-title="國立臺北大學民俗藝術與文化資產研究所副教授兼所長" :data-image="translatedSpeakers[29].image"
                          data-bio="投入文化資產研究、民俗藝術與教育推廣。" data-speech="座談三：青年世代的產業文化資產保存行動" @click="openModal(29)"><span
                            class="speaker-box"><b-img :src="translatedSpeakers[29].image" fluid
                              :alt="translatedSpeakers[29].name"></b-img><span><span class="role">{{ $t(translatedSpeakers[29].role) }}</span><span
                                class="name">{{ translatedSpeakers[29].name }}</span><span class="title">{{ translatedSpeakers[29].title }}</span></span></span></button>
                      </div>
                    </div>
                  </article>

                  <article class="item">
                    <div class="time">17:10–17:20</div>
                    <div class="content">
                      <div class="bar gray">{{ $t("Agenda_closing") }}</div>
                    </div>
                  </article>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
          <div class="text-center">{{ $t("Agenda_End") }}</div>
        </b-card>
      </b-container>

      <!-- model -->
      <div class="Agenda-modal" :class="{ open: showModal }" @click.self="closeModal">
        <div class="modal-card">
          <button class="Agenda-close" aria-label="關閉" @click="closeModal">×</button>
          <div class="modal-head">
            <b-img :src="currentSpeaker.image" fluid :alt="$t(currentSpeaker.name)"></b-img>
            <div>
              <div class="modal-role">{{ $t(currentSpeaker.role)}}</div>
              <h2 class="modal-name">{{ $t(currentSpeaker.name) }}</h2>
              <p class="modal-title">{{ $t(currentSpeaker.title) }}</p>
            </div>
          </div>
          <div class="modal-body">
            <template v-if="$t(currentSpeaker.bio)">
              <h4>{{ $t('Speaker_Bio') }}</h4>
              <p style="white-space: pre-line;">{{ $t(currentSpeaker.bio) }}</p>
            </template>
            <template v-if="$t(currentSpeaker.edu)">
              <h4>{{ $t('Guest_Education') }}</h4>
              <p style="white-space: pre-line;">{{ $t(currentSpeaker.edu) }}</p>
            </template>
            <template v-if="$t(currentSpeaker.exp)">
              <h4>{{ $t('Guest_Experience') }}</h4>
              <p style="white-space: pre-line;">{{ $t(currentSpeaker.exp) }}</p>
            </template>
          </div>
        </div>
      </div>

    </div>
    <ul id="myMenu">
      <li>
        <b-link to="/" tooltip="首頁" flow="left"
          ><span class="icon-home" :title="$t('rightNav01')"></span
          ><span class="sr-only">{{ $t("TopNav01") }}</span>
        </b-link>
      </li>
      <li>
        <a
          href="https://www.surveycake.com/s/DrWBR"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-user-plus"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>

  </div>


</template>
<script>
export default {
  data() {
    return {
      navigationActive: [],
      items: [
        {
          text: this.$t("TopNav01"),
          href: "#/",
        },
        {
          text: this.$t("TopNav04"),
          active: true,
        },
      ],
      showModal: false,
      activeSpeaker: 0,
      speakers: [
        { role: "Moderator", name: "speaker_0_name", title: "speaker_0_title", edu: "speaker_0_edu", exp: "speaker_0_exp", bio: "speaker_0_bio", image: require("@/assets/imgs/guest/Li-Yuan.jpg") },
        { role: "GuestRemarks", name: "speaker_1_name", title: "speaker_1_title", edu: "speaker_1_edu", exp: "speaker_1_exp", bio: "speaker_1_bio", image: require("@/assets/imgs/guest/CHEN_CHI-MING.jpg") },
        { role: "GuestRemarks", name: "speaker_2_name", title: "speaker_2_title", edu: "speaker_2_edu", exp: "speaker_2_exp", bio: "speaker_2_bio", image: require("@/assets/imgs/guest/Li-Yuan.jpg") },
        { role: "GuestRemarks", name: "speaker_3_name", title: "speaker_3_title", edu: "speaker_3_edu", exp: "speaker_3_exp", bio: "speaker_3_bio", image: require("@/assets/imgs/guest/Marion-Steiner.webp") },
        { role: "Moderator", name: "speaker_4_name", title: "speaker_4_title", edu: "speaker_4_edu", exp: "speaker_4_exp", bio: "speaker_4_bio", image: require("@/assets/imgs/guest/CHEN_CHI-MING.jpg") },
        { role: "Speaker", name: "speaker_5_name", title: "speaker_5_title", edu: "speaker_5_edu", exp: "speaker_5_exp", bio: "speaker_5_bio", image: require("@/assets/imgs/guest/Chao-Ching Fu.jpg") },
        { role: "Speaker", name: "speaker_6_name", title: "speaker_6_title", edu: "speaker_6_edu", exp: "speaker_6_exp", bio: "speaker_6_bio", image: require("@/assets/imgs/guest/Moulshri Joshi.jpg") },
        { role: "Speaker", name: "speaker_7_name", title: "speaker_7_title", edu: "speaker_7_edu", exp: "speaker_7_exp", bio: "speaker_7_bio", image: require("@/assets/imgs/guest/Faisal Abd Rahman.jpg") },
        { role: "Speaker", name: "speaker_8_name", title: "speaker_8_title", edu: "speaker_8_edu", exp: "speaker_8_exp", bio: "speaker_8_bio", image: require("@/assets/imgs/guest/Mitsuko Nishikawa.jpg") },
        { role: "Speaker", name: "speaker_9_name", title: "speaker_9_title", edu: "speaker_9_edu", exp: "speaker_9_exp", bio: "speaker_9_bio", image: require("@/assets/imgs/guest/Chao-Ching Fu.jpg") },
        { role: "Speaker", name: "speaker_10_name", title: "speaker_10_title", edu: "speaker_10_edu", exp: "speaker_10_exp", bio: "speaker_10_bio", image: require("@/assets/imgs/guest/Moulshri Joshi.jpg") },
        { role: "Speaker", name: "speaker_11_name", title: "speaker_11_title", edu: "speaker_11_edu", exp: "speaker_11_exp", bio: "speaker_11_bio", image: require("@/assets/imgs/guest/Faisal Abd Rahman.jpg") },
        { role: "Speaker", name: "speaker_12_name", title: "speaker_12_title", edu: "speaker_12_edu", exp: "speaker_12_exp", bio: "speaker_12_bio", image: require("@/assets/imgs/guest/Mitsuko Nishikawa.jpg") },
        { role: "Panelist", name: "speaker_13_name", title: "speaker_13_title", edu: "speaker_13_edu", exp: "speaker_13_exp", bio: "speaker_13_bio", image: require("@/assets/imgs/guest/Hsiao_Wei_Lin.jpg") },
        { role: "Moderator", name: "speaker_14_name", title: "speaker_14_title", edu: "speaker_14_edu", exp: "speaker_14_exp", bio: "speaker_14_bio", image: require("@/assets/imgs/guest/Hsiao_Wei_Lin.jpg") },
        { role: "Speaker", name: "speaker_15_name", title: "speaker_15_title", edu: "speaker_15_edu", exp: "speaker_15_exp", bio: "speaker_15_bio", image: require("@/assets/imgs/guest/Miles Oglethorpe.jpg") },
        { role: "Speaker", name: "speaker_16_name", title: "speaker_16_title", edu: "speaker_16_edu", exp: "speaker_16_exp", bio: "speaker_16_bio", image: require("@/assets/imgs/guest/Yung-Hui Chou.jpg") },
        { role: "Speaker", name: "speaker_17_name", title: "speaker_17_title", edu: "speaker_17_edu", exp: "speaker_17_exp", bio: "speaker_17_bio", image: require("@/assets/imgs/guest/Chien-lung,Huang.jpg") },
        { role: "Speaker", name: "speaker_18_name", title: "speaker_18_title", edu: "speaker_18_edu", exp: "speaker_18_exp", bio: "speaker_18_bio", image: require("@/assets/imgs/guest/Miles Oglethorpe.jpg") },
        { role: "Speaker", name: "speaker_19_name", title: "speaker_19_title", edu: "speaker_19_edu", exp: "speaker_19_exp", bio: "speaker_19_bio", image: require("@/assets/imgs/guest/Yung-Hui Chou.jpg") },
        { role: "Speaker", name: "speaker_20_name", title: "speaker_20_title", edu: "speaker_20_edu", exp: "speaker_20_exp", bio: "speaker_20_bio", image: require("@/assets/imgs/guest/Chien-lung,Huang.jpg") },
        { role: "Panelist", name: "speaker_21_name", title: "speaker_21_title", edu: "speaker_21_edu", exp: "speaker_21_exp", bio: "speaker_21_bio", image: require("@/assets/imgs/guest/YI-CHEN LIN.jpg") },
        { role: "Moderator", name: "speaker_22_name", title: "speaker_22_title", edu: "speaker_22_edu", exp: "speaker_22_exp", bio: "speaker_22_bio", image: require("@/assets/imgs/guest/Sin-Heng_Wang.jpg") },
        { role: "Speaker", name: "speaker_23_name", title: "speaker_23_title", edu: "speaker_23_edu", exp: "speaker_23_exp", bio: "speaker_23_bio", image: require("@/assets/imgs/guest/Min-chang Cheng.jpg") },
        { role: "Speaker", name: "speaker_24_name", title: "speaker_24_title", edu: "speaker_24_edu", exp: "speaker_24_exp", bio: "speaker_24_bio", image: require("@/assets/imgs/guest/Bin-Feng Yan.jpg") },
        { role: "Speaker", name: "speaker_25_name", title: "speaker_25_title", edu: "speaker_25_edu", exp: "speaker_25_exp", bio: "speaker_25_bio", image: require("@/assets/imgs/guest/Sheng-Kai Hsu.jpg") },
        { role: "Speaker", name: "speaker_26_name", title: "speaker_26_title", edu: "speaker_26_edu", exp: "speaker_26_exp", bio: "speaker_26_bio", image: require("@/assets/imgs/guest/Min-chang Cheng.jpg") },
        { role: "Speaker", name: "speaker_27_name", title: "speaker_27_title", edu: "speaker_27_edu", exp: "speaker_27_exp", bio: "speaker_27_bio", image: require("@/assets/imgs/guest/Bin-Feng Yan.jpg") },
        { role: "Speaker", name: "speaker_28_name", title: "speaker_28_title", edu: "speaker_28_edu", exp: "speaker_28_exp", bio: "speaker_28_bio", image: require("@/assets/imgs/guest/Sheng-Kai Hsu.jpg") },
        { role: "Panelist", name: "speaker_29_name", title: "speaker_29_title", edu: "speaker_29_edu", exp: "speaker_29_exp", bio: "speaker_29_bio", image: require("@/assets/imgs/guest/Chun-Hsi Wang.jpg") },
      ],
    };
  },
  computed: {
    translatedSpeakers() {
      return this.speakers.map(s => ({
        ...s,
        name: this.$t(s.name),
        title: this.$t(s.title),
      }));
    },
    currentSpeaker() {
      return this.translatedSpeakers[this.activeSpeaker] || {};
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    openModal(index) {
      this.activeSpeaker = index;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style lang="scss"></style>
